import { render } from "./FileConf.vue?vue&type=template&id=453f44e5&scoped=true"
import script from "./FileConf.vue?vue&type=script&lang=js"
export * from "./FileConf.vue?vue&type=script&lang=js"

import "./FileConf.vue?vue&type=style&index=0&id=453f44e5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453f44e5"]])

export default __exports__